import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { priceListSegment, priceListSegmentType } from '../../types/slices/priceListSegmentType'

const initialState: priceListSegmentType =
{
    status: ApiStatus.FETCHED,
    priceListSegment: [],
    priceListSelectedSegment: {} as priceListSegment,
    errorMessage: undefined,
    action: ''
}

const priceListSegmentSlice = createSlice({
    name: 'priceListSegmentSlice',
    initialState,
    reducers: {
        onFetchPriceListSegment (state, { payload }: { payload: priceListSegment[]}) {
            state.status = ApiStatus.FETCHED
            state.priceListSegment = payload
            state.errorMessage = undefined
        },
        onSetSelectedPriceListSegment (state, { payload }: { payload: priceListSegment }) {
            state.priceListSelectedSegment = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectPriceListSegmentState = (state: RootState) => state.priceListSegmentSlice
export default priceListSegmentSlice.reducer
export const {
    onFetchPriceListSegment,
    onSetSelectedPriceListSegment,
    changeStatus,
    setAction,
} = priceListSegmentSlice.actions
